import { css } from '@emotion/react'
import theme from '../theme'

export default css`
    .ant-tooltip .ant-tooltip-inner,
    .ant-tooltip .ant-tooltip-arrow:before {
        background-color: ${theme.colors.disabled.main};
    }
`
